module.exports = __webpack_public_path__ + "static/media/Apple-App-Store.2e725873.svg";